import { addMessage } from 'Flux/Slice/Application/ApplicationSlice.js'
import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { errorMessage } from 'Model/Message/IMessage.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const PostSampleEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.postContentRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      OrderRepository.setContent(action.payload.orderId, action.payload.poolId, action.payload.sample).pipe(
        mergeMap((response) =>
          of(order.postSampleRequestSuccess({ orderId: action.payload.orderId, poolId: action.payload.poolId, content: response }))
        ),
        // Without this the failure escapes into the outer mergeMap and tears the whole epic down for
        // the rest of the session: every later file pair would silently stop creating its sample. With
        // an upload of hundreds of pairs that is invisible until the order fails to submit.
        catchError((error: Error) => {
          console.error('Failed to create sample from uploaded files', error)
          return of(
            addMessage(
              errorMessage(
                'A sample could not be created from its uploaded files. ' +
                  'The files are uploaded — please reload the page and check the pool before submitting.'
              )
            )
          )
        })
      )
    )
  )
